<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Licenc</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-card color="danger" *ngIf="!license || license.activated == 0">
    <ion-card-header>
      <ion-card-title>Sikertelen aktiválás</ion-card-title>
    </ion-card-header>
    <ion-card-content> A terméket nem sikerül aktiválni! Amennyiben ez egy hiba, kérjük, vegye fel a kapcsolatot a rendszergazdával. </ion-card-content>
  </ion-card>
  <ion-card color="success" *ngIf="license && license.activated == 1">
    <ion-card-header>
      <ion-card-title>A termék aktiválva és naprakész</ion-card-title>
    </ion-card-header>
    <ion-card-content> A termék sikeresen kapcsolódott az aktiválási szerverekhez és a legfrissebb verziót használja! </ion-card-content>
  </ion-card>
  <ion-card color="warning" *ngIf="license && license.activated == 2">
    <ion-card-header>
      <ion-card-title>A termék aktiválva de elavult</ion-card-title>
    </ion-card-header>
    <ion-card-content> A termék sikeresen kapcsolódott az aktiválási szerverekhez, de nem a legfrissebb verziót használja! </ion-card-content>
  </ion-card>
<ion-card>
  <ion-card-content>
    <ion-grid>
      <ion-row>
        <ion-col>
          <div style="display:flex; flex-wrap: wrap;">
            <div style="margin-right:5px">
          <img src="/api/file/203508/logo.png" width="50px">
            </div><div>
          Előfizető neve:<br>
          <h1><b>{{license?.jogosult}}</b></h1>
            </div>
          </div>
          <br>
          Típus: <b>{{license?.name}}</b><br>
          Érvényesség: <b>{{license?.expire}}</b><br>
          Azonosító: <b>{{license?.address}}</b><br><br>
          <a href="#">Előfizetés módosítása</a>
        </ion-col>
        <ion-col>
          <div style="display:flex; flex-wrap: wrap;">
            <div style="margin-right:5px">
              <img src="/assets/icon/favicons.png" style="border-radius: 50%" width="50px">
            </div><div>
            Termék neve:<br>
            <h1><b>Sulinform</b></h1>
          </div>
          </div>
          <br>
          Programverzió: <b>{{environment.version}}</b><br>
          <a href="/changelog">Frissítési jegyzék</a><br>
          <a href="#">Névjegy</a><br><br>
          <a href="#">Hibaelárítás</a>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
</ion-content>
